<app-window-title
  [closable]="mode === 'change'"
  [title]="mode === 'change' ? 'Change Password' : 'Password Expiration'"
  (closed)="onCancel()"></app-window-title>

<form *ngIf="updateUserPasswordForm"
      [formGroup]="updateUserPasswordForm"
      (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <p class="dialog-description">
      <span *ngIf="mode === 'expiry'">Your password has expired. Please provide a new password for your account.</span>
      <span *ngIf="mode === 'change'">Enter your current password and choose a new one.</span>
    </p>

    <!-- CURRENT PASSWORD -->
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Current password</mat-label>
      <input class="password-input"
             required
             formControlName="currentPasswordFormControl"
             matInput>
      <mat-error *ngIf="checkError(updateUserPasswordForm, 'currentPasswordFormControl', 'required')">
        Current password is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <!-- NEW PASSWORD -->
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>New password</mat-label>
      <input class="password-input"
             required
             formControlName="newPasswordFormControl"
             matInput>
      <mat-error *ngIf="updateUserPasswordForm.controls['newPasswordFormControl'].invalid">
        <span *ngIf="checkError(updateUserPasswordForm, 'newPasswordFormControl', 'required')">
          New password is <strong>required</strong>
        </span>
        <span *ngIf="checkError(updateUserPasswordForm, 'newPasswordFormControl', 'minlength')">
          New password should have at least 6 characters.
        </span>
        <span *ngIf="checkError(updateUserPasswordForm, 'newPasswordFormControl', 'passwordStrength')">
          New password is not strong enough.
        </span>
      </mat-error>
    </mat-form-field>

    <mat-password-strength #passwordComponent
                           [password]="updateUserPasswordForm.controls.newPasswordFormControl.value"
                           (onStrengthChanged)="onStrengthChanged($event)">
    </mat-password-strength>

    <div class="strength-toggle" (click)="showPasswordInfo = !showPasswordInfo">
      <mat-icon class="strength-toggle-icon">{{ showPasswordInfo ? 'expand_less' : 'expand_more' }}</mat-icon>
      <span>Password requirements</span>
    </div>
    <mat-password-strength-info *ngIf="showPasswordInfo"
                                [passwordComponent]="passwordComponent">
    </mat-password-strength-info>

    <!-- CONFIRM NEW PASSWORD -->
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Confirm new password</mat-label>
      <mat-pass-toggle-visibility #toggle_cp matSuffix></mat-pass-toggle-visibility>
      <input class="password-input"
             required
             formControlName="confirmPasswordFormControl"
             matInput
             [type]="$any(toggle_cp).type">
      <mat-error *ngIf="checkError(updateUserPasswordForm, 'confirmPasswordFormControl', 'required')">
        Confirm new password is <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="checkError(updateUserPasswordForm, 'confirmPasswordFormControl', 'minlength')">
        New password should have at least 6 characters.
      </mat-error>
      <mat-error *ngIf="f['confirmPasswordFormControl'].errors && f['confirmPasswordFormControl'].errors['matching']">
        Passwords do not match
      </mat-error>
    </mat-form-field>
  </div>

  <div mat-dialog-actions style="justify-content: space-between; padding: 8px 24px 16px">
    <div>
      <button color="warn" type="submit" mat-flat-button>
        Update Password
      </button>
      <button *ngIf="mode === 'change'"
              type="button"
              mat-button
              style="margin-left: 8px"
              (click)="onCancel()">
        Cancel
      </button>
    </div>
    <button *ngIf="mode === 'expiry'"
            color="warn"
            type="button"
            mat-stroked-button
            (click)="handleLogOut()">
      Logout
    </button>
  </div>
</form>
